{
  "de": {
    "salesWizard": {
      "steps": {
        "contact": "Kontaktdaten",
        "license": "Lizenz-Auswahl",
        "workshops": "Workshops",
        "school": "Schule"
      },
      "contactStep": {
        "headline": "Kontaktformular für Schulen",
        "description": "Bitte tragen Sie Ihre Kontaktdaten ein, damit wir Ihnen alle nötigen Informationen zuschicken können. Achten Sie besonders auf die korrekte Schreibweise Ihrer E-Mail-Adresse.",
        "formOfAddress": "Anrede",
        "formOfAddressFemale": "Frau",
        "formOfAddressMale": "Herr",
        "firstname": "Vorname",
        "lastname": "Nachname",
        "email": "E-Mail-Adresse",
        "phone": "Telefon"
      },
      "entry": {
        "loading": "Das Kontaktformular wird vorbereitet …",
        "error": "Das Kontaktformular konnte nicht gestartet werden. Bitte laden Sie die Seite neu oder versuchen Sie es später erneut."
      },
      "confirmation": {
        "headline": "Vielen Dank für Ihre Anfrage!",
        "offerSingle": "Sie erhalten zeitnah ein Angebot an folgende E-Mail-Adresse:",
        "offerMultiple": "Sie erhalten zeitnah verschiedene Angebote an folgende E-Mail-Adresse:",
        "support": "Sollten in der Zwischenzeit Fragen auftauchen, wenden Sie sich gern an unseren Support unter",
        "notFound": "Diese Anfrage wurde nicht gefunden. Bitte prüfen Sie den Link oder starten Sie eine neue Anfrage."
      },
      "saveError": "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "choiceStep": {
        "headline": "Wählen Sie jetzt eine oder mehrere Lizenz-Optionen aus",
        "description": "Pro Lizenzpaket erhalten Sie ein Angebot, sodass Sie diese vergleichen können.",
        "numOfEmployees": "Größe des Kollegiums",
        "maxMembersCount": "Anzahl benötigter Lizenzen",
        "package": "Wählen Sie ihr passendes Lizenzpaket aus",
        "packageLabels": {
          "package_s": "S-Lizenz",
          "package_m": "M-Lizenz",
          "package_l": "L-Lizenz",
          "package_xl": "XL-Lizenz"
        },
        "upto": "Bis",
        "people": "Personen",
        "aboveLimit": {
          "headline": "Individuelles Angebot für mehr als 120 Personen",
          "description": "Für Angebot mit über 120 Lizenzen beraten wir Sie gerne persönlich. Bitte rufen Sie uns an unter",
          "or": "oder",
          "chooseAppointment": "vereinbaren Sie einen Beratungstermin"
        },
        "bavaria": {
          "headline": "Wichtig Infos für Bayern zum Medien- und KI-Budget:",
          "intro": "Folgende Lizenzpakete können laut Förderrichtlinie und nach Absprache mit dem bayerischen Landesamt für Schule finanziert werden:",
          "items": {
            "allInclusive": "All-Inclusive-Schullizenz (100% förderfähig)",
            "tools": "Tools-Schullizenz (100% förderfähig)",
            "toTeach": "To Teach-Schullizenz (100% förderfähig)",
            "combo": "Kombi-Schullizenz (nur anteilig förderfähig)"
          },
          "moreInfo": "Weitere Informationen und einen Beratungslink finden Sie hier:"
        },
        "subHeadlineCombined": "Profitieren Sie von unseren Kombi-Paketen",
        "subHeadlineProduct": "Oder wählen Sie hier einzelne Produkte aus",
        "popular": "Beliebt",
        "year": "Jahr",
        "licenceItemsEmpty": "Es muss mindestens ein Lizenztyp ausgewählt werden.",
        "configLoadError": "Die Lizenz-Optionen konnten nicht geladen werden."
      },
      "workshopStep": {
        "headline": "Digitale Workshops",
        "description": "Empfehlung: Ein jährlicher Workshop für das Kollegium ist ideal für eine erfolgreiche fobizz Nutzung und höhere Zufriedenheit.",
        "itemTypes": {
          "workshop": "Praxisworkshop",
          "presentation": "Impulsvortrag",
          "consulting": "individuelle Beratung"
        },
        "durationMinutes": "{duration} Minuten",
        "details": "Workshop Details",
        "configLoadError": "Die Workshop-Optionen konnten nicht geladen werden.",
        "incompleteRequest": "Die Anfrage konnte nicht abgeschickt werden, da frühere Schritte unvollständig sind. Bitte gehen Sie zurück und vervollständigen Sie Ihre Angaben."
      },
      "schoolStep": {
        "headline": "Kontaktformular für Schulen",
        "description": "Wählen Sie hier Ihre Schule aus:",
        "searchHint": "Sie können nach Postleitzahl oder Schulname suchen.",
        "notFoundHint": "Falls Sie Ihre Schule nicht finden, setzen Sie bitte ein Häkchen unten und tragen die Daten selbst ein.",
        "searchLabel": "Schule",
        "searchPlaceholder": "Schule suchen …",
        "searchFieldHint": "Tipp: Sie können nach Postleitzahl oder Schulname suchen",
        "noResults": "Keine Schule gefunden.",
        "initialRequest": "Meine Schule ist nicht dabei",
        "companyName": "Name der Einrichtung",
        "street": "Straße und Hausnummer",
        "zipcode": "Postleitzahl",
        "city": "Stadt",
        "countryCode": "Land",
        "kind": "Bildungseinrichtung",
        "schoolType": "Schultyp",
        "schoolTypeCustom": "Sonstiger Schultyp",
        "baseError": "Schule auswählen oder Haken \"Meine Schule ist nicht dabei\" setzen und Daten selbst eintragen"
      },
      "taxInfo": "Alle Preise inkl. Mehrwertsteuer {rate}% (bzw. die jeweils geltende MwSt.)",
      "retry": "Erneut versuchen",
      "back": "Zurück"
    }
  }
}
